export default __webpack_public_path__ + "static/media/i142vp.b535f8cb.webp";